export enum DocumentCategory {
  Authorization,
  Billing,
  Contracts,
  Medical,
  Misc,
  PT,
}
